import { FunctionComponent, PropsWithChildren } from "react";
import { Dialog } from "@headlessui/react";
import { cn } from "../../utils/cn";

export interface ModalDescriptionProps {
  className?: string;
  "data-testid"?: string;
}

/**
 *
 */
export const ModalDescription: FunctionComponent<
  PropsWithChildren<ModalDescriptionProps>
> = ({ className, children, "data-testid": dataTestId }) => {
  const testId = dataTestId || "modal-description";
  return (
    <Dialog.Description className={cn(className)} data-testid={testId}>
      {children}
    </Dialog.Description>
  );
};
